import axios from "axios";

export const API_URL = `${process.env.REACT_APP_API_URL}/itemtypes`;

// CREATE =>  POST: add a new product to the server
export function createItemType(itemtype) {
    return axios.post(API_URL, { ...itemtype });
}

// READ
export function getAllItemTypes() {
    return axios.get(API_URL);
}

export function getPaginatedItemTypes(queryParams) {
    return axios.post(`${API_URL}/list`, { ...queryParams });
}

export function getItemTypeById(itemtypeId) {
    return axios.get(`${API_URL}/${itemtypeId}`);
}



// // Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// // items => filtered/sorted result
// export function findProducts(queryParams) {
//     return axios.post(`${API_URL}/find`, { queryParams });
// }

// UPDATE => PUT: update the itemtype on the server
export function updateItemType(itemtypeId, itemtype) {
    return axios.put(`${API_URL}/${itemtypeId}`, { ...itemtype });
}


// DELETE => delete the product from the server
export function deleteItemType(itemtypeId) {
    return axios.delete(`${API_URL}/${itemtypeId}`);
}
